import { Th, Thead, Tr } from '@chakra-ui/table';
import React from 'react';
import { HeaderGroup } from 'react-table';
import colors from '../../../../../../../styles/colors';

// eslint-disable-next-line @typescript-eslint/ban-types
interface TableHeadProps<Data extends object> {
  headerGroups: HeaderGroup<Data>[];
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function TableHead<Data extends object>({ headerGroups }: TableHeadProps<Data>): JSX.Element {
  return (
    <Thead>
      {headerGroups.map((headerGroup) => {
        const { key: headerGroupKey, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
        return (
          <Tr key={headerGroupKey} {...headerGroupProps} textAlign="left">
            {headerGroup.headers.map((column) => {
              const { key: columnKey, ...columnProps } = column.getHeaderProps(column.getSortByToggleProps());
              return (
                <Th
                  key={columnKey}
                  {...columnProps}
                  isNumeric={column.isNumeric}
                  h="29px"
                  px="12px"
                  textTransform="none"
                  color={colors.gray[450]}
                  bg={colors.gray_50}
                  borderBottom={`2px solid ${colors.gray[250]}`}
                  border={`1px solid ${colors.gray[250]}`}
                  fontSize="12px"
                  fontWeight={600}
                  width={column.width}
                  textAlign={column.isNumeric ? 'right' : 'left'}
                >
                  {column.render('Header')}
                </Th>
              );
            })}
          </Tr>
        );
      })}
    </Thead>
  );
}
